import { ShippingRateLima } from "../../Domain/Model/ShippingRateLima";
import { ShippingRateProvince } from "../../Domain/Model/ShippingRateProvince";
import { ShippingRepository } from "../../Domain/Repository/ShippingRepository";
import ShippingDataSource from "../DataSource/ShippingDataSource";

export class ShippingRepositoryImpl implements ShippingRepository {
    dataSource: ShippingDataSource;

    constructor(_datasource: ShippingDataSource) {
        this.dataSource = _datasource;
    }

    getShippingRatesProvince(): Promise<ShippingRateProvince[]> {
        return this.dataSource.getShippingRatesProvince();
    }

    getShippingRatesLima(): Promise<ShippingRateLima[]> {
        return this.dataSource.getShippingRatesLima();
    }
}